import React, { useState } from "react";

import { MDBBtn, MDBIcon, MDBModalFooter, MDBSpinner } from "mdb-react-ui-kit";
import {
  deleteAAGroup,
  deleteCallFlows,
  deleteUser,
} from "../../../apiclients/streamsapi_bridge.js";
import { useTranslation } from "react-i18next";

const DeleteCallFlow = (props) => {
  const { t, i18n } = useTranslation();
  const [isloading, setIsloading] = useState(false);
  async function removeThisItem(e) {
    setIsloading(true);
    console.log(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
    let deleteGrp = await deleteCallFlows(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      props.call_flow.call_flow_id
    );
    setTimeout(() => {
      setIsloading(false);
    }, 1000);
    let deleteMsg = await deleteGrp.json();
    console.log("Response... ");
    if (deleteMsg.status == "success") {
      localStorage.setItem("s_message", "Call flow removed successfully.");
      window.location.href = "/callflowlanding";
    } else {
      localStorage.setItem("f_message", deleteMsg.message);
      props.onClose();
      window.location.href = "/callflowlanding";
    }
  }
  return (
    <>
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
      <div>
        <div className="d-flex align-items-center bg-danger bg-opacity-25 p-3  rounded-3 square border border-2 border-danger">
          <MDBIcon fas icon="ban" className="me-3" size="lg" color="danger" />
          <span>{t("RemoveCallFlowtxt")}</span>
        </div>

      </div>
      <MDBModalFooter className="p-0 mt-3 pt-2">
        <MDBBtn color="secondary" onClick={props.onClose}>
          {t("cancel")}
        </MDBBtn>
        <MDBBtn onClick={(e) => removeThisItem(e)}>{t("remove")}</MDBBtn>
      </MDBModalFooter>
    </>
  );
};

export default DeleteCallFlow;
